import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userReducer from './slices/user/userSlice';
import forgotPassReducer from './slices/auth/forgotPassSlice';
import profileReducer from './slices/user/profileSlice';
import searchReducer from './slices/search/searchSlice';
import loginReducer from './slices/auth/loginSlice';
import dashboardReducer from './slices/dashboard/dashboardSlice';
import homeReducer from './slices/home/homeSlice';
import tableSortValuesReducer from './slices/tableSortValues/tableSortValues.slice';
import transactionReducer from './slices/transaction/transactionSlice';
import propertiesReducer from './slices/properties/propertiesSlice';
import tenantsReducer from './slices/tenants/tenantsSlice';
import matchesReducer from './slices/matches/matchesSlice';
import agreementsReducer from './slices/agreements/agreementsSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    forgotPassModal: forgotPassReducer,
    userProfile: profileReducer,
    globalSearch: searchReducer,
    login: loginReducer,
    dashboard: dashboardReducer,
    home: homeReducer,
    tableSortValues: tableSortValuesReducer,
    transactions: transactionReducer,
    properties: propertiesReducer,
    tenants: tenantsReducer,
    matches: matchesReducer,
    agreements: agreementsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['bills/setBillSuccessData'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.subtitle.$$typeof'],
        // Ignore these paths in the state
        ignoredPaths: ['bills.billSuccessData.subtitle']
      }
    })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
